import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareShareIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 17 16' {...props}>
    <path
      d='M13.519 8.994a.5.5 0 00-.5.5v4.521H1V2h5.51a.5.5 0 000-1H1.5A1.5 1.5 0 000 2.5v11.016a1.5 1.5 0 001.5 1.5h11.018a1.5 1.5 0 001.5-1.5V9.494a.5.5 0 00-.499-.5z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M15.806 3.576L11.938.136a.562.562 0 00-.929.425L11 3.007c-2.7 0-6.04.915-6.04 3.786a4.783 4.783 0 001.95 3.606.418.418 0 00.656-.436C5.628 6.133 8.682 5 11 5l.01 2.672a.562.562 0 00.93.425l3.867-3.673a.561.561 0 000-.848z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M13.52 8.994a.5.5 0 00-.5.5v4.521H1V2h5.51a.5.5 0 000-1H1.5A1.5 1.5 0 000 2.5v11.016a1.5 1.5 0 001.5 1.5h11.018a1.5 1.5 0 001.5-1.5V9.494a.5.5 0 00-.499-.5z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
    <path
      d='M16.807 3.576L12.94.136a.562.562 0 00-.929.425L12 3.007c-2.7 0-7.042.915-7.042 3.786a4.783 4.783 0 001.95 3.606.417.417 0 00.657-.436C5.628 6.133 9.683 5 12.001 5l.01 2.672a.562.562 0 00.93.425l3.867-3.673a.561.561 0 000-.848z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const ShareIcon = memo(BareShareIcon);
